<div class="app-dialog visualise-dialog">
  <div class="app-dialog__heading dialog-header">
    <div class="app-dialog__heading-copy">
      <span class="app-dialog__eyebrow">Visualisation</span>
      <div class="app-dialog__title-row">
        <div class="app-dialog__title-copy">
          <h2 mat-dialog-title class="app-dialog__title">{{ data.columnName }} Visualisation</h2>
        </div>
      </div>
    </div>
    <div class="header-controls">
      <!-- Graph Type Dropdown -->
      <mat-select [(value)]="selectedGraphType" (selectionChange)="onGraphTypeChange()" class="graph-type-select">
        <mat-option *ngFor="let graphType of availableGraphTypes" [value]="graphType.value">
          {{ graphType.label }}
        </mat-option>
      </mat-select>
      
      <button mat-icon-button (click)="onCancel()" class="close-button">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </div>
  </div>
  
  <div mat-dialog-content class="app-dialog__content dialog-content">
    <div class="chart-wrapper" 
         [class.has-y-axis-selector]="selectedGraphType === 'scatter' && !data.hideYAxisSelector"
         [class.has-x-axis-selector]="selectedGraphType === 'scatter' || selectedGraphType === 'iqr'">
      <!-- Y-axis selector for scatter plots (left side) -->
      <div *ngIf="selectedGraphType === 'scatter' && !data.hideYAxisSelector" class="y-axis-selector">
        <mat-select 
          [(value)]="selectedSecondColumn" 
          (selectionChange)="onSecondColumnChange()"
          class="axis-column-select y-axis"
          [placeholder]="getSecondColumnPlaceholder()">
          <mat-option *ngFor="let column of getAvailableYColumns()" [value]="column">
            {{ column }}
          </mat-option>
        </mat-select>
      </div>
      
      <!-- Container for chart and X-axis selector -->
      <div class="chart-and-x-axis-container" [class.has-selected-data]="selectedData.length > 0">
      <div class="chart-container" #chartContainer>
        <!-- Loading spinner -->
        <div *ngIf="isLoading" class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>Loading chart...</p>
        </div>
        
        <!-- Error message -->
        <div *ngIf="errorMessage" class="error-message">
          <mat-icon svgIcon="error_outline"></mat-icon>
          <p>{{ errorMessage }}</p>
        </div>
        
        <!-- Interactive Chart Component -->
        <app-interactive-chart
          *ngIf="chartData && !isLoading && !errorMessage"
          [chartData]="chartData"
          [chartType]="selectedGraphType"
          [dataSourceId]="data.dataSourceId"
          [uploadedData]="data.uploadedData"
          [columnName]="selectedGraphType === 'scatter' ? selectedXColumn : data.columnName"
          [secondColumnName]="selectedSecondColumn"
          [showDataTable]="false"
          [anomalyIndices]="data.anomalyIndices"
          (selectionChange)="onSelectionChange($event)"
          class="interactive-chart">
        </app-interactive-chart>
        
        <!-- Placeholder when no chart is available -->
        <div *ngIf="!chartData && !isLoading && !errorMessage" class="placeholder-text">
          Select a graph type to display visualization
        </div>
      </div>
      
      <!-- X-axis selector for scatter and IQR charts (below chart) -->
      <div *ngIf="(selectedGraphType === 'scatter' && !data.hideXAxisSelector) || selectedGraphType === 'iqr'" class="x-axis-selector">
        <mat-select 
          *ngIf="selectedGraphType === 'scatter'"
          [(value)]="selectedXColumn" 
          (selectionChange)="onXColumnChange()"
          class="axis-column-select x-axis"
          [placeholder]="getXColumnPlaceholder()">
          <mat-option *ngFor="let column of getAvailableXColumns()" [value]="column">
            {{ column }}
          </mat-option>
        </mat-select>
        
        <mat-select 
          *ngIf="selectedGraphType === 'iqr'"
          [(value)]="selectedSecondColumn" 
          (selectionChange)="onSecondColumnChange()"
          class="axis-column-select x-axis"
          [placeholder]="getSecondColumnPlaceholder()">
          <mat-option value="">None (Single Column IQR)</mat-option>
          <mat-option *ngFor="let column of getAvailableColumns()" [value]="column">
            {{ column }}
          </mat-option>
        </mat-select>
      </div>
      
      <!-- Selected Data Table (below X-axis selector) -->
      <div *ngIf="selectedData.length > 0" class="data-table-section">
        <div class="table-container">
          <table mat-table [dataSource]="selectedData">
            <!-- Dynamic columns -->
            <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
              <td mat-cell *matCellDef="let row">
                <div class="cell-content">{{ row[column] }}</div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </div>
      </div>
    </div>
    
    <!-- Export button for selected data -->
    <div *ngIf="selectedData.length > 0" class="export-section">
      <button mat-raised-button (click)="clearSelection()">
        <mat-icon>clear</mat-icon>
        Clear Selection
      </button>
      <button mat-raised-button color="primary" (click)="onExport()">
        <mat-icon>download</mat-icon>
        Export Selected Data ({{ selectedData.length }} rows)
      </button>
    </div>
  </div>
</div>
